import React, {useState,useRef,useEffect} from 'react';
import {Form, Input, Button, Tabs , Modal, AutoComplete, message} from 'antd';
import {http, history} from 'libs';
import styles from './login.module.less';

// the hook
import {useTranslation} from 'react-i18next';

const {Option} = AutoComplete;
const {Password} = Input

export default function ForgetPassword() {
  const {t, i18n} = useTranslation();
  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState('1');

  const [countdown, setCountdown] = useState(0);      // 倒计时秒数，0 表示未开始
  const [sending, setSending] = useState(false); // 是否正在发送验证码
  const timerRef = useRef(null);                      // 存储定时器 ID
  const [form] = Form.useForm();

  // 倒计时逻辑
  const startCountdown = (seconds = 60) => {
    if (timerRef.current) return;                     // 防止重复开始
    setCountdown(seconds);
    timerRef.current = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          // 倒计时结束，清除定时器
          clearInterval(timerRef.current);
          timerRef.current = null;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // 组件卸载时清除定时器
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  useEffect(() => { 
    form.resetFields();
  }, [activeKey]);

  // 获取字段配置映射
  const getFieldConfig = () => {
    return activeKey === '1'
      ? { field: 'phone', api: '/javaApi/user/sendSmsCode', codeField: 'smsCode' }
      : { field: 'email', api: '/javaApi/user/sendEmailCode', codeField: 'emailCode' };
  };

  const handleClick = async () => {
    if (countdown > 0||sending) return; // 倒计时中，不处理

    const { field, api } = getFieldConfig();

    try {
      await form.validateFields([field]); // 校验对应字段
      setSending(true);
      const response = await http.post(api, {
        [field]: form.getFieldValue(field),
        type:2,
      });
      startCountdown(60);
    } catch (error) {
      message.error(error);
    } finally {
      setSending(false);
    }
  };

  const onChangeTabs = (key) => {
    setActiveKey(key);
  }

  const handleSubmit = async () => {
    setLoading(true);
    const { field, codeField } = getFieldConfig();
    const api = activeKey === '1'
      ? '/javaApi/user/resetPasswordBySms'
      : '/javaApi/user/resetPasswordByEmail';

    try {
      await http.post(api, {
        [field]: form.getFieldValue(field),
        [codeField]: form.getFieldValue(codeField),
        newPassword: form.getFieldValue('newPassword'),
        confirmPassword: form.getFieldValue('confirmPassword'),
      });

      Modal.success({
        title: '密码修改成功',
        content: (
          <div>
            <p>请使用新密码登录</p>
          </div>
        ),
        okText: '前往登录',
        onOk() {
          history.push('/login');
        },
      });
    } catch (error) {
      console.error('Reset password failed:', error);
      Modal.error({
        title: '密码修改失败',
        content: error || '请稍后重试',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={[styles.container, styles.forgetPassword].join(" ")}>
      <div className={styles.formContainer}>
        <Form form={form} onFinish={handleSubmit} validateTrigger='onBlur'>
          <Tabs
            activeKey={activeKey}
            onChange={onChangeTabs}
            items={[
              {
                label: `通过手机号找回`,
                key: '1',
                children:  <Form.Item
            label={t('手机号码')}
            name="phone"
            rules={[
              {required: activeKey === '1', message: t('请输入手机号') + '!'},
              {pattern: /^[1]([3-9])[0-9]{9}$/, message: t('请输入正确的手机号码')}
            ]}
            className={styles.formItem}>
            <Input autoComplete="off" placeholder={t('请输入手机号')}/>
          </Form.Item>,
              },
              {
                label: `通过邮箱找回`,
                key: '2',
                children:  <Form.Item
            label={t('电子邮箱')}
            name="email"
            rules={[
              {required: activeKey === '2', message: t('请输入电子邮箱') + '!'},
              {type: 'email', message: t('邮箱格式不正确') + '!'}
            ]}
            className={styles.formItem}>
            <Input autoComplete="new-password" placeholder={t('请输入电子邮箱')}/>
          </Form.Item>,
              },
            ]}
          />
          <Form.Item
            label={t('验证码')}
            name=""
            required={true}
            className={styles.formItem}>
            <Form.Item name={getFieldConfig().codeField} noStyle  rules={[
              {required: true, message: t('请输入验证码') + '!'}
            ]}><Input className={styles.codeInput} autoComplete="off" placeholder={t('请输入验证码')}/></Form.Item>
            <Button className={styles.getCodeBtn} onClick={handleClick} disabled={countdown > 0||sending} type="primary">{countdown > 0 ? countdown + '秒后重试' : t('获取验证码')}</Button>
          </Form.Item>
          <Form.Item
            label={t('设置密码')}
            name="newPassword"
            rules={[
              {required: true, message: t('请设置登录密码') + '!'},
              {pattern:/^(?:(?=.*\d)(?=.*[a-zA-Z])|(?=.*\d)(?=.*[^a-zA-Z0-9])|(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])).{8,20}$/, message: t('密码8‑20位，需包含数字、字母、特殊字符至少两种') + '!'}
            ]}
            className={styles.formItem}>
            <Password autoComplete="new-password" className='rest-password' placeholder={t('密码8‑20位，需包含数字、字母、特殊字符至少两种') + '!'}/>
          </Form.Item>

          <Form.Item
            label={t('确认密码')}
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              {required: true, message: t('请再次输入密码') + '!'},
              ({getFieldValue}) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(t('两次输入密码不一致') + '!');
                },
              }),
            ]}
            className={styles.formItem}>
            <Password autoComplete="new-password" className='rest-password' placeholder={t('请再次输入密码')}/>
          </Form.Item>
      
          <Form.Item>
            <Button size="large" type="primary" htmlType="submit" loading={loading}>{t('确认修改密码')}</Button>
          </Form.Item>

        </Form>
      </div>

    </div>
  )
}